"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncIterableOf = void 0;
/** @internal */
async function* asyncIterableOf(item) {
    yield item;
}
exports.asyncIterableOf = asyncIterableOf;
//# sourceMappingURL=asyncIterableOf.js.map